const severityLevels = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
export { severityLevels };
